/** Split an array into consecutive chunks of size `n`. */
export function chunkArray<T>(arr: T[], n: number): T[][] {
  if (n <= 0) return [arr];
  const result: T[][] = [];
  for (let i = 0; i < arr.length; i += n) {
    result.push(arr.slice(i, i + n));
  }
  return result;
}
